import React from 'react';

import { useTheme } from '@rtkwlf/fenrir-react';
import clsx from 'clsx';
import { Outlet } from 'react-router-dom';

import { TrackApiProvider } from '@apis/track-public/api-provider';
import type { Pod } from '@apis/track-public/types';
import { useAuthContext } from '@packages/legacy/auth';
import { useOrganizationContext } from '@packages/legacy/organization-context';

import { PageMetaProvider } from './components/page-meta-provider';
import styles from './main.module.css';

export const MainLayout = () => {
  const theme = useTheme();
  const { selectedOrganization } = useOrganizationContext();

  const { fetchApi } = useAuthContext();

  React.useEffect(() => {
    const body = document.body;
    body.classList.add('c3-themes', theme?.themeMode ?? '');
    body.setAttribute('c3-scaling', '100%');
    body.setAttribute('data-accent-color', 'arctic');

    return () => {
      body.classList.remove('c3-themes', theme?.themeMode ?? '');
      body.removeAttribute('c3-scaling');
      body.removeAttribute('data-accent-color');
    };
  }, [theme?.themeMode]);

  return (
    <TrackApiProvider
      fetch={fetchApi}
      orgID={selectedOrganization.id}
      pod={selectedOrganization.pod as Pod}
    >
      <PageMetaProvider>
        <div
          className={clsx(
            'c3-themes',
            theme?.themeMode,
            styles['main'],
            styles[theme?.themeMode ?? 'light'],
          )}
          data-accent-color="arctic"
          c3-scaling="100%"
        >
          <Outlet />
        </div>
      </PageMetaProvider>
    </TrackApiProvider>
  );
};
